<template>
<v-layout row wrap >
  <v-flex xs12 sm6 order-xs2 order-sm1 >
  <v-list class='pb-0' >
    <v-text-field
      label='Search' v-model='searchString'
      prepend-icon='search' clearable solo ></v-text-field>
    <v-subheader>
      <help-popover>{{ $t('help.text') }}</help-popover>
      {{ $t('help.title') }}
    </v-subheader>
    <template v-for='item in filteredAppointments' >
    <v-list-tile v-if='!item.invoiceable' :key='item.id' >
      <v-list-tile-action>
        <v-checkbox v-model='selected' :value='item.id'>
        </v-checkbox>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title >{{item.title || item.full_name}}</v-list-tile-title>
        <v-list-tile-sub-title>
          {{dateformat(item.start_time)}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-tooltip left >
        <v-btn slot='activator' :to='`/appointments/${item.id}`' icon >
          <v-icon>open_in_new</v-icon>
        </v-btn>
        <span>Go to appointment</span>
        </v-tooltip>
      </v-list-tile-action>
    </v-list-tile>
    <v-divider :key='`d-${item.id}`' ></v-divider>
    </template>
  </v-list>
  </v-flex>
  <transition name='slide-fade' appear mode='in-out' >
    <v-flex sm6 xs12 order-xs1 order-sm2 >
      <transition appear mode='out-in' name='fade' >
      <v-card v-if='selected && selected.length > 0' >
        <v-card-title class='subheading' >
          <v-chip color='primary' dark text-color="white" >
            {{selected.length}} selected appointments
          </v-chip>
        </v-card-title>
        <v-card-text>
          <v-expansion-panel v-model='exandr' class='elevation-4' >
            <v-expansion-panel-content >
              <div slot="header">Invoice details</div>
              <v-card>
                <v-card-text>
                  <v-alert :value='showSuccessNotification' color='success' dismissible >
                    Selected appointments successfully updated
                  </v-alert>
                  <blockquote class='blockquote px-0' >
                    Set the invoice title and description for {{selected.length}} appointments
                  </blockquote>
                  <v-text-field
                    v-model='appointmentData.invoice_title'
                    label='Invoice title'
                    hint="The line item title we will show on invoices" >
                  </v-text-field>
                  <v-text-field
                    v-model='appointmentData.invoice_description'
                    label='Invoice description'
                    hint="An optional extra description to show on the invoice" >
                  </v-text-field>
                </v-card-text>
                <v-card-actions >
                  <v-spacer></v-spacer>
                  <v-btn @click='save'
                    :loading="invoiceDataRequest.loading"
                    color='primary'>Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content >
              <div slot="header">Add Codes</div>
              <v-divider></v-divider>
              <v-card class='grey lighten-4' >
                <v-card-text>
                  <bulk-add-codes :appointment-ids='selected' >
                  </bulk-add-codes>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

        <transition name='slide' appear >
        <v-card flat class='my-4' v-if='selected && selected.length > 0' >
          <v-card-actions class='pa-0' >
            <v-btn block
              @click='markInvoiceable'
              :loading='markInvoiceableRequest.loading' >
              <v-icon class='mx-2'>check_circle_outline</v-icon>
              Mark {{selected.length}} appointments as invoiceable
            </v-btn>
          </v-card-actions>
        </v-card>
        </transition>
        </v-card-text>
      </v-card>
      </transition>
    </v-flex>
  </transition>
  <vuex-snackbar
    :req-id='bulkReqId'
    success-message='Appointments marked as invoiceable'
    error-message='Unable to update invoices. Please try again' >
  </vuex-snackbar>
  <vuex-snackbar
    :req-id='bulkReqIdData'
    success-message='Appointments updated'
    error-message='Unable to update invoices. Please try again' >
  </vuex-snackbar>
</v-layout >
</template>

<script>
import BulkAddCodes from '@/components/appointment/BulkAddCodes'
import HelpPopover from '@/components/ui/HelpPopover'

export default {
  name: 'InvoiceMasterDetail',
  components: {BulkAddCodes, HelpPopover},
  props: {
    appointments: { type: Array, default: () => { return {} } }
  },
  data () {
    return {
      exandr: [],
      codeMode: 'new',
      bulkReqId: 'appointment-bulk-request-invoiceable',
      bulkReqIdData: 'appointment-bulk-request-update',
      selected: [],
      searchString: null,
      appointmentData: {
        invoice_title: '',
        invoice_description: ''
        // invoiceable: ''
      }
    }
  },
  watch: {
    markInvoiceableRequestStatus () {
      if (this.markInvoiceableRequestStatus === 200) {
        this.selected = []
        this.getAppointmentsInRange()
      }
    },
    invoiceDataRequestStatus () {

    },
    totalAppointments () {
      this.selected = []
    }
  },
  computed: {
    markInvoiceableRequest () {
      return this.$store.getters.getRequestById(this.bulkReqId, true)
    },
    markInvoiceableRequestStatus () {
      return this.markInvoiceableRequest.status
    },
    invoiceDataRequest () {
      return this.$store.getters.getRequestById(this.bulkReqIdData, true)
    },
    invoiceDataRequestStatus () {
      return this.invoiceDataRequest.status
    },
    showSuccessNotification () {
      return this.invoiceDataRequestStatus === 200
    },
    filteredAppointments () {
      if (this.searchString) {
        return this.appointments.filter((appt) => {
          let index = `{appt.title} ${appt.invoice_title} ${appt.full_name}`
          let containsString = (
            index.toLowerCase()
              .indexOf(this.searchString.toLowerCase()) > -1
          )
          return containsString
        })
      }
      return this.appointments
    },
    totalAppointments () {
      if (this.appointments) {
        return this.appointments.length
      }
      return 0
    }
  },
  methods: {
    save () {
      let ids = this.selected.join(',')
      let payload = this.appointmentData
      this.$appointmentguru
        .resource('appointment.bulk')
        .id(this.bulkReqIdData)
        .save(ids, payload)
    },
    markInvoiceable () {
      let ids = this.selected.join(',')
      let payload = {invoiceable: true}
      this.$appointmentguru
        .resource('appointment.bulk')
        .id(this.bulkReqId)
        .save(ids, payload)
    }
  },
  i18n: {
    messages: {
      en: {
        help: {
          title: 'These appointments are not marked as invoiceable',
          text: 'Appointments not marked as invoiceable might need some extra information. You may want to add ICD10 codes etc. On this page you can update multiple appointments at once.'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AppointmentsTodo.vue?061a4b08